module.exports = __webpack_public_path__ + "static/logo-5616c305eddec9f885349a2c4fc20523.png";